import React from 'react';
import { useTranslation } from 'react-i18next';

import Base from '../Base';
import Title from '../../components/common/Title';
import MetPeopleList from '../../components/common/MetPeopleList';

/* /my-connections — the standalone "People you met" screen.

   ★ The list itself lives in MetPeopleList, because My Network shows the same thing in a tab and
   that tab is the entry point everyone reaches. This route is kept rather than redirected: it is
   the URL the feature shipped with, and a page that still answers is cheaper than a link that
   404s somewhere we have not thought of. */
const MetPeople = () => {
  const { t } = useTranslation();

  return (
    <Base activeNav="home">
      <Title title={t('meetPeopleTitle')} />
      <MetPeopleList />
    </Base>
  );
};

export default MetPeople;
